import { useMemo } from "react";
import {
  RAFFLE_HISTORY_DAYS,
  getWheelRaffleErrorMessage,
  selectHistory,
  useGetRafflesHistoryQuery,
} from "entities/wheel-raffle";
import { useClientPage } from "./useClientPage";

export const useRaffleHistory = () => {
  const result = useGetRafflesHistoryQuery(RAFFLE_HISTORY_DAYS, {
    refetchOnMountOrArgChange: true,
  });
  const items = useMemo(() => selectHistory(result.data ?? []), [result.data]);

  return {
    ...useClientPage(items),
    isLoading: result.isLoading,
    isFetching: result.isFetching,
    errorMessage: getWheelRaffleErrorMessage(result.error),
  };
};
